import React from "react";
import { Wrapper } from "./CustomerListCard.styled";
import { Row, Col } from "components/common";
import CustomerListCardEntity from "./CustomerListCardEntity/CustomerListCardEntity";
import filter from "../../../assets/images/filter.png";

const CustomerListCard = ({ data, showDefaultDrawer, date }) => {
  return (
    <Wrapper>
      <Row>
        <Col span={24} className="filter">
          <img
            src={filter}
            className="pointer"
            onClick={() => {
              showDefaultDrawer();
            }}
            alt=""
          />
        </Col>
      </Row>
      <Row gutter={[15, 15]}>
        {date == "" ? (
          <>
            {data.map((item) => {
              return (
                <Col xs={24}>
                  <CustomerListCardEntity data={item} />
                </Col>
              );
            })}
          </>
        ) : (
          <>
            {date.map((item) => {
              return (
                <Col xs={24}>
                  <CustomerListCardEntity data={item} />
                </Col>
              );
            })}
          </>
        )}
      </Row>
    </Wrapper>
  );
};

export default CustomerListCard;
